@if (minBetSize && maxBetSize) {
  <div class="config-container">
    <span class="stake-info">
      <span class="label">Min Bet:</span>
      <b class="value">{{ minBetSize | number: "1.0-2" }}</b>
    </span>
    <span class="stake-info">
      <span class="label">Max Bet:</span>
      <b class="value">{{ maxBetSize | number: "1.0-2" }}</b>
    </span>
  </div>
}